// extracted by mini-css-extract-plugin
export default {"small":"only screen and (min-width: 576px)","color-grey-1":"#707070","colorGrey1":"#707070","breadcrumbs":"bBjM3","breadcrumb":"_8jdqS","currentPage":"hR35o"};